import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Table,
  message,
  Popconfirm,
} from "antd";
import { TNA_DUE_DATE } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { useEffect, useState } from "react";
import {
  cglFormatDate,
  commaSeparateNumber,
  isArrayAndHasValue,
} from "../../../../../utils/functions";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";

const ItemEdit = (props) => {
  const {
    selectedItem,
    getTNATaskList,
    TNATaskList,
    closeDrawer,
    onUpdateItem,
    onAddNewItem,
    isDrawerOpen,
    userList,
    itemDetailsList,
    TNAStyles,
    TNAPos,
    getUserList,
    planCutDates,
  } = props;

  const [editForm] = Form.useForm();
  const { Option } = Select;

  const [rows, setRows] = useState([]);
  const [isScType, setIsScType] = useState(false);
  const [currentRelationType, setCurrentRelationType] = useState(null);
  const [columnTitle, setColumnTitle] = useState("Items");
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    if (selectedItem) {
      editForm.setFieldsValue({
        tna_process_id: selectedItem?.tna_process_id,
        tna_process_title: selectedItem?.tna_process_title,
        task_dependencies: selectedItem?.task_dependencies,
        tna_department_name: selectedItem?.tna_department_name,
        style_wise: selectedItem?.style_wise,
        po_wise: selectedItem?.po_wise,
        is_pcd: selectedItem?.is_pcd,
        is_ship: selectedItem?.is_ship,
        tna_task_name: selectedItem?.tna_task_name,
        tna_task_id: selectedItem?.tna_task_id,
        responsible_person_id: selectedItem?.responsible_person_id,
        responsible_person_name: selectedItem?.responsible_person_name,
      });

      let initialRows = [];

      if (selectedItem?.task_dates && selectedItem.task_dates.length > 0) {
        initialRows = selectedItem.task_dates.map((dateEntry, idx) => ({
          key: idx.toString(),
          ids:
            selectedItem?.style_wise === "Yes"
              ? dateEntry.styles?.map((style) => style.id) || []
              : selectedItem?.po_wise === "Yes"
              ? dateEntry.purchase_orders?.map((po) => po.id) || []
              : [],
          names:
            selectedItem?.style_wise === "Yes"
              ? dateEntry.styles?.map((style) => style.style_no) || []
              : selectedItem?.po_wise === "Yes"
              ? dateEntry.purchase_orders?.map((po) => po.original_po) || []
              : [],
          days: dateEntry.days,
          due_date: dateEntry.due_date || "",
        }));
      } else if (
        selectedItem?.relation_with === "Style" &&
        isArrayAndHasValue(selectedItem?.style_ids)
      ) {
        initialRows = [
          {
            key: "0",
            ids: selectedItem?.style_ids || [],
            names: selectedItem?.style_names || [],
            days: selectedItem?.days || 0,
            due_date: selectedItem?.due_date || "",
          },
        ];
      } else if (
        selectedItem?.relation_with === "PO" &&
        isArrayAndHasValue(selectedItem?.po_ids)
      ) {
        initialRows = [
          {
            key: "0",
            ids: selectedItem?.po_ids || [],
            names: selectedItem?.po_names || [],
            days: selectedItem?.days || 0,
            due_date: selectedItem?.due_date || "",
          },
        ];
      } else if (selectedItem?.relation_with === "SC") {
        setIsScType(true);
        initialRows = [
          {
            key: "0",
            ids: [],
            names: [],
            days: selectedItem?.days || 0,
            due_date: selectedItem?.due_date || "",
          },
        ];
      } else {
        initialRows = [
          {
            key: "0",
            ids: [],
            names: [],
            days: selectedItem?.days || 0,
            due_date: selectedItem?.due_date || "",
          },
        ];
      }

      if (initialRows.length === 0) {
        initialRows = [
          {
            key: "0",
            ids: [],
            names: [],
            days: selectedItem?.days || 0,
            due_date: selectedItem?.due_date || "",
          },
        ];
      }

      setRows(initialRows);

      if (selectedItem?.style_wise === "Yes") {
        setCurrentRelationType("Style");
        setColumnTitle("Styles");
      } else if (selectedItem?.po_wise === "Yes") {
        setCurrentRelationType("PO");
        setColumnTitle("Purchase Orders");
      } else if (selectedItem?.relation_with === "SC") {
        setCurrentRelationType("SC");
        setColumnTitle("Sales Contracts");
      }

      const updatedRows = [...initialRows];
      let hasChanges = false;

      for (let i = 0; i < updatedRows.length; i++) {
        if (updatedRows[i].days && !updatedRows[i].due_date) {
          const dueDate = calculateDueDate(updatedRows[i].days);
          updatedRows[i].due_date = dueDate;
          hasChanges = true;
        }
      }

      if (hasChanges) {
        setRows(updatedRows);
      }
    } else {
      setRows([{ key: "0", ids: [], names: [], days: 0, due_date: "" }]);

      const calculateInitialDueDate = async () => {
        if (planCutDates) {
          const dueDate = calculateDueDate(0);
          setRows([
            { key: "0", ids: [], names: [], days: 0, due_date: dueDate },
          ]);
        } else {
          setRows([{ key: "0", ids: [], names: [], days: 0, due_date: "" }]);
        }
      };

      calculateInitialDueDate();
    }

    if (selectedItem?.relation_with === "SC") {
      setIsScType(true);
    } else {
      setIsScType(false);
    }
  }, [selectedItem, editForm, isDrawerOpen, planCutDates]);

  const onCancel = () => {
    editForm.resetFields();
    closeDrawer();
  };

  const parseDate = (dateStr) => {
    const formats = ["DD-MMM-YYYY", "YYYY-MM-DD", "MM/DD/YYYY", "DD/MM/YYYY"];

    for (const format of formats) {
      const parsedDate = moment(dateStr, format, true);
      if (parsedDate.isValid()) {
        return parsedDate;
      }
    }

    const defaultParse = moment(dateStr);
    return defaultParse.isValid() ? defaultParse : null;
  };

  const calculateDueDate = (days) => {
    if (!planCutDates) {
      return "";
    }

    try {
      let dates = [];
      if (Array.isArray(planCutDates)) {
        dates = planCutDates.map((date) => parseDate(date));
      } else {
        const parsedDate = parseDate(planCutDates);
        if (parsedDate) {
          dates = [parsedDate];
        }
      }

      if (!dates.length || !dates[0] || !dates[0].isValid()) {
        console.error("Invalid plan cut dates format:", planCutDates);
        return "";
      }

      dates.sort((a, b) => a - b);
      const earliestDate = dates[0];

      const dueDate = earliestDate.clone().add(parseInt(days, 10), "days");

      return dueDate.format("DD-MMM-YYYY");
    } catch (error) {
      console.error("Error calculating due date:", error);
      return "";
    }
  };

  const getDueDate = async (value) => {
    if (planCutDates) {
      return calculateDueDate(value);
    }

    const query = `${TNA_DUE_DATE}/${value}`;
    const response = await getData(query);

    if (response && response?.data?.code === 200) {
      const apiDate = response?.data?.data?.due_date;
      const parsedDate = parseDate(apiDate);
      return parsedDate ? parsedDate.format("DD-MMM-YYYY") : apiDate;
    } else {
      message.error("Error getting due date");
      return "";
    }
  };

  const handleDaysChange = async (value, key) => {
    const dueDate = await getDueDate(value);
    const updatedRows = rows.map((row) => {
      if (row.key === key) {
        return { ...row, days: value, due_date: dueDate };
      }
      return row;
    });
    setRows(updatedRows);
  };

  const handleIdsChange = (value, key) => {
    const updatedRows = rows.map((row) => {
      if (row.key === key) {
        let names = [];
        if (currentRelationType === "Style") {
          names = value.map((id) => {
            const foundStyle = TNAStyles?.find((item) => item?.id === id);
            return foundStyle?.style_no || "";
          });
        } else if (currentRelationType === "PO") {
          names = value.map((id) => {
            const foundPO = TNAPos?.find((item) => item?.id === id);
            return foundPO?.original_po || "";
          });
        }
        return { ...row, ids: value, names: names };
      }
      return row;
    });
    setRows(updatedRows);
  };

  useEffect(() => {
    const newSelectedIds = rows.reduce((acc, row) => {
      return [...acc, ...row.ids];
    }, []);
    setSelectedIds(newSelectedIds);
  }, [rows]);

  const addRow = async () => {
    const lastRow = rows[rows.length - 1];
    if (!lastRow.ids || lastRow.ids.length === 0) {
      message.error("Please select at least one value before adding a new row");
      return;
    }

    const newKey = Date.now().toString();

    const dueDate = await getDueDate(0);

    setRows([
      ...rows,
      { key: newKey, ids: [], names: [], days: 0, due_date: dueDate },
    ]);
  };

  const removeRow = (key) => {
    if (rows.length <= 1) {
      message.warning("At least one row is required");
      return;
    }
    const updatedRows = rows.filter((row) => row.key !== key);
    setRows(updatedRows);
  };

  const onSelectTask = (id) => {
    const foundTask = TNATaskList?.find((item) => item?.id === id);
    console.log("🚀 ~ onSelectTask ~ foundTask:", foundTask);

    editForm.setFieldsValue({
      tna_process_id: foundTask?.process?.id,
      tna_process_title: foundTask?.process?.title,
      tna_department_name: foundTask?.department?.title,
      style_wise: foundTask?.relation_with === "Style" ? "Yes" : "No",
      po_wise: foundTask?.relation_with === "PO" ? "Yes" : "No",
      is_pcd: foundTask?.is_pcd === 1 ? "Yes" : "No",
      is_ship: foundTask?.is_shipment === 1 ? "Yes" : "No",
      tna_task_name: foundTask?.title,
    });

    const isScRelation = foundTask?.relation_with === "SC";
    setIsScType(isScRelation);
    setCurrentRelationType(foundTask?.relation_with);

    if (foundTask?.relation_with === "Style") {
      setColumnTitle("Styles");
    } else if (foundTask?.relation_with === "PO") {
      setColumnTitle("Purchase Orders");
    } else if (foundTask?.relation_with === "SC") {
      setColumnTitle("Sales Contracts");
    }

    if (foundTask?.task_dates && foundTask.task_dates.length > 0) {
      const newRows = foundTask.task_dates.map((dateEntry, idx) => ({
        key: idx.toString(),
        ids: [],
        names: [],
        days: dateEntry.days || 0,
        due_date: dateEntry.due_date || "",
      }));
      setRows(newRows);
    } else {
      const dueDate = calculateDueDate(foundTask?.days || 0);

      setRows([
        {
          key: Date.now().toString(),
          ids: [],
          names: [],
          days: foundTask?.days || 0,
          due_date: dueDate || "",
        },
      ]);
    }
  };

  const onUpdateOrAdd = (values) => {
    let task_data = {};

    const task_payload = {
      tna_task_id: values.tna_task_id,
      responsible_person_id: values.responsible_person_id,
    };

    if (values.style_wise === "Yes") {
      task_payload.task_styles = rows.map((row) => ({
        style_ids: row.ids,
        days: row.days || 0,
      }));
    } else if (values.po_wise === "Yes") {
      task_payload.task_purchase_orders = rows.map((row) => ({
        po_map_ids: row.ids,
        days: row.days || 0,
      }));
    } else if (isScType) {
      task_payload.task_sales_contracts = rows.map((row) => ({
        sales_contract_ids: row.ids,
        days: row.days || 0,
      }));
    }

    const task_dates = rows.map((row) => ({
      days: row.days || 0,
      due_date: row.due_date || "",
      styles:
        values.style_wise === "Yes"
          ? row.ids.map((id, idx) => ({
              id: id,
              style_no: row.names[idx] || "",
            }))
          : [],
      purchase_orders:
        values.po_wise === "Yes"
          ? row.ids.map((id, idx) => ({
              id: id,
              original_po: row.names[idx] || "",
            }))
          : [],
    }));

    const preservedValues = {
      ...values,
      days: rows[0]?.days || 0,
      due_date: rows[0]?.due_date || "",
      task_dates: task_dates,

      style_ids: values.style_wise === "Yes" ? rows[0]?.ids || [] : [],
      style_names: values.style_wise === "Yes" ? rows[0]?.names || [] : [],
      po_ids: values.po_wise === "Yes" ? rows[0]?.ids || [] : [],
      po_names: values.po_wise === "Yes" ? rows[0]?.names || [] : [],
    };

    if (selectedItem) {
      onUpdateItem(selectedItem?.index, preservedValues);
      editForm.resetFields();
    } else {
      onAddNewItem(preservedValues);
      editForm.resetFields();
    }
  };

  const columns = [
    {
      title: columnTitle,
      dataIndex: "ids",
      key: "ids",
      width: "60%",
      render: (ids, record) => {
        const allOptions =
          currentRelationType === "Style" && isArrayAndHasValue(TNAStyles)
            ? TNAStyles?.map((item) => ({
                label: item?.style_no,
                value: item?.id,
                disabled:
                  selectedIds.includes(item?.id) && !ids.includes(item?.id),
              }))
            : currentRelationType === "PO" && isArrayAndHasValue(TNAPos)
            ? TNAPos?.map((item) => ({
                label: item?.original_po,
                value: item?.id,
                disabled:
                  selectedIds.includes(item?.id) && !ids.includes(item?.id),
              }))
            : [];

        const enabledOptions = allOptions.filter((option) => !option.disabled);

        const handleSelectChange = (value) => {
          if (value.includes("select_all")) {
            const enabledIds = enabledOptions.map((option) => option.value);
            handleIdsChange(enabledIds, record.key);
          } else if (value.includes("unselect_all")) {
            handleIdsChange([], record.key);
          } else {
            handleIdsChange(value, record.key);
          }
        };

        const isAllSelected =
          enabledOptions.length > 0 &&
          enabledOptions.every((option) => ids.includes(option.value));

        return (
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            value={ids}
            placeholder={
              currentRelationType === "Style"
                ? "Select Styles"
                : currentRelationType === "PO"
                ? "Select POs"
                : ""
            }
            onChange={handleSelectChange}
            disabled={isScType}
            optionFilterProp="children"
            filterOption={(input, option) => {
              return option?.label
                ?.toLowerCase()
                ?.includes(input?.toLowerCase());
            }}
            options={[
              isAllSelected
                ? { label: "Unselect All", value: "unselect_all" }
                : { label: "Select All", value: "select_all" },
              ...allOptions,
            ]}
            size="small"
          />
        );
      },
    },
    {
      title: "Days",
      dataIndex: "days",
      key: "days",
      width: "15%",
      render: (days, record) => (
        <InputNumber
          style={{ width: "100%" }}
          formatter={(value) => (value ? commaSeparateNumber(value) : "")}
          value={record.days}
          onChange={(value) => handleDaysChange(value, record.key)}
          disabled={false}
          size="small"
          placeholder="Days"
        />
      ),
    },
    {
      title: "Due Date",
      dataIndex: "due_date",
      key: "due_date",
      width: "25%",
      render: (due_date) => (
        <Input
          size="small"
          placeholder="Due Date"
          value={cglFormatDate(due_date)}
          disabled
        />
      ),
    },
    {
      title: "",
      key: "action",
      width: "5%",
      render: (_, record) => (
        <Popconfirm
          title="Are you sure to delete this row?"
          onConfirm={() => removeRow(record.key)}
          okText="Yes"
          cancelText="No"
          disabled={isScType}
        >
          <Button
            icon={<DeleteOutlined />}
            size="middle"
            danger
            disabled={isScType}
          />
        </Popconfirm>
      ),
    },
  ];

  return (
    <Form form={editForm} layout="vertical" onFinish={onUpdateOrAdd}>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="tna_task_name" hidden />
          <Form.Item
            name="tna_task_id"
            label="Task"
            rules={[
              {
                required: true,
                message: "Task is required",
              },
            ]}
          >
            <Select
              dropdownStyle={{ minWidth: 250 }}
              className="w-100"
              showSearch
              onSearch={(e) => getTNATaskList(e)}
              onSelect={(value) => {
                onSelectTask(value);
              }}
              allowClear
              onClear={() => {
                getTNATaskList();
                editForm.setFieldsValue({
                  tna_process_id: undefined,
                  tna_process_title: undefined,
                  tna_department_name: undefined,
                  style_wise: undefined,
                  po_wise: undefined,
                  is_pcd: undefined,
                  is_ship: undefined,
                  tna_task_name: undefined,
                });
                setCurrentRelationType(null);
                setColumnTitle("Items");
                setRows([
                  { key: "0", ids: [], names: [], days: 0, due_date: "" },
                ]);
                setIsScType(false);
              }}
              placeholder="Select a Task"
              optionFilterProp="children"
              size="small"
            >
              {isArrayAndHasValue(TNATaskList) &&
                TNATaskList?.map((item) => (
                  <Option value={item?.id} key={item?.id}>
                    {item?.title}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="tna_process_id" hidden />
          <Form.Item name="tna_process_title" label="Process">
            <Input size="small" placeholder="Process" disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="tna_department_name" label="Department">
            <Input size="small" placeholder="Department" disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="style_wise" label="Style Wise">
            <Input size="small" placeholder="Style Wise" disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="po_wise" label="PO Wise">
            <Input size="small" placeholder="PO Wise" disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="is_pcd" label="PCD">
            <Input size="small" placeholder="PCD" disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="is_ship" label="Ship">
            <Input size="small" placeholder="Ship" disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="responsible_person_name" hidden />
          <Form.Item
            name="responsible_person_id"
            label="Responsible"
            rules={[
              {
                required: true,
                message: "Responsible is required",
              },
            ]}
          >
            <Select
              dropdownStyle={{ minWidth: 250 }}
              className="w-100"
              showSearch
              placeholder="Select responsible person"
              optionFilterProp="children"
              dropdownMatchSelectWidth={false}
              size="small"
              onSelect={(value) => {
                const foundUser = userList?.find((user) => user?.id === value);
                editForm.setFieldValue(
                  "responsible_person_name",
                  foundUser?.name,
                );
              }}
              // onSearch={(value) => getUserList(value)}
              // filterOption={(input, option) => {
              //   return option?.label
              //     ?.toLowerCase()
              //     ?.includes(input?.toLowerCase());
              // }}
              allowClear
              onClear={() => getUserList()}
            >
              {isArrayAndHasValue(userList) &&
                userList?.map((item) => (
                  <Option value={item?.id} key={item?.id}>
                    {item?.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Dependency" name="task_dependencies">
            <Select
              mode="multiple"
              showSearch
              placeholder="Select dependencies"
              optionFilterProp="children"
              filterOption={(input, option) => {
                return option?.label
                  ?.toLowerCase()
                  ?.includes(input?.toLowerCase());
              }}
              options={
                isArrayAndHasValue(itemDetailsList) &&
                itemDetailsList?.map((item) => ({
                  label: item?.tna_task_name,
                  value: item?.tna_task_id,
                }))
              }
              size="small"
            />
          </Form.Item>
        </Col>
      </Row>

      {/* Table for multiple rows */}
      <div style={{ marginBottom: "16px" }}>
        <Table
          columns={columns}
          dataSource={rows}
          pagination={false}
          size="small"
          bordered
        />

        <Button
          type="dashed"
          onClick={addRow}
          style={{ marginTop: "10px" }}
          icon={<PlusOutlined />}
          size="small"
          disabled={isScType}
        >
          Add
        </Button>
      </div>

      <Row gutter={6}>
        <Col span={12}>
          <Button
            style={{ width: "100%" }}
            type="primary"
            htmlType="submit"
            size="small"
          >
            {selectedItem ? `Update` : `Add`}
          </Button>
        </Col>
        <Col span={12}>
          <Button
            style={{ width: "100%" }}
            type="danger"
            size="small"
            onClick={onCancel}
          >
            Cancel
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default ItemEdit;
